import { render, staticRenderFns } from "./xcx.vue?vue&type=template&id=33a3a526&"
import script from "./xcx.vue?vue&type=script&lang=js&"
export * from "./xcx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports